function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
import tasks from '@/js/tasks';
import utils from '@/js/utils';
import { ROLES_LIST, PERIODS, PATTERNS_VALIDATION, DATAPLEX_STATES } from '@/js/constants';
import DialogsComponent from "@/components/DialogsComponent.vue";
import dataplex_service from '@/apps/data-platform/services/data_quality/dataplex_service';
import assignments_service from "@/apps/data-platform/services/tables_views/assignments_service";
import UserSecurityService from '@/apps/data-platform/services/security/user_security_service';
import TextFieldCalendarComponent from "@/components/TextFieldCalendarComponent";
import TextFieldRecipientsComponent from "@/components/TextFieldRecipientsComponent";
import ProfilingExecutionDetailComponent from "@/apps/data-platform/modules/data_quality_dataplex/components/ProfilingExecutionDetailComponent";
import ProjectPermissionComponent from "../../components/ProjectPermissionComponent.vue";
import project_service from '@/apps/chatbots/services/projects_services';
import bots_services from '@/apps/chatbots/services/bots_services';
import data_center_services from "../../services/data_center_services";
import CreateDataCenterComponent from "../datacenter/CreateDataCenterComponent.vue";
import CreateChannelComponent from "../channels/CreateChannelComponent.vue";
export default {
  components: {
    TextFieldCalendarComponent: TextFieldCalendarComponent,
    TextFieldRecipientsComponent: TextFieldRecipientsComponent,
    ProfilingExecutionDetailComponent: ProfilingExecutionDetailComponent,
    ProjectPermissionComponent: ProjectPermissionComponent,
    CreateDataCenterComponent: CreateDataCenterComponent,
    CreateChannelComponent: CreateChannelComponent
  },
  data: function data() {
    return {
      DATAPLEX_STATES: DATAPLEX_STATES,
      stepper: 1,
      PREFIX: 'INCA_dp_',
      PREFIX_ID: 'inca-dp-',
      tab: 0,
      edit: false,
      view: false,
      filters: {},
      show_detail: false,
      filter_enabled: true,
      collapse_filter: false,
      emailPattern: PATTERNS_VALIDATION.EMAIL_GENERAL,
      execution_selected: {},
      errors_recipients: [],
      last_modification_table: null,
      single_datastore: null,
      project: {
        "deployed": true,
        "cloud_resource": {},
        "chatbot_type": "",
        "chatbot": {},
        "monitor": {
          "development": {
            "total_cost": 0.02,
            "total_questions": 24,
            "total_tokens": 510,
            "count_users": 10
          }
        },
        "version_metadata": {
          "prompt_params": {
            "assistant_name": "NoBot",
            "assistant_role": "Bot Informativo",
            "company_name": "DataOffice",
            "company_activity": "Datos",
            "conversation_purpose": " - Atender las consultas de los usuarios con muchos animos y responder de forma consiza.\n- Si el usuario hace preguntas ambiguas puedes solicitarle informacion que consideres relavante.\n- Objetivo Principal: Solicitar informaci\xF3n de contactabilidad y responder las preguntas de los clientes."
          },
          "config_params": {
            "temperature": 0.5,
            "model_name": "",
            "k_top_retrieval": 3,
            "max_token_history": 500,
            "k_top_history": 20,
            "max_minutes": 10
          },
          "datastores": [],
          "tags": []
        }
      },
      bots: [],
      connections: [],
      datastore: [],
      rules: {
        name: [function (v) {
          return !!v || 'El campo es requerido.';
        }, function (v) {
          return v && v.length <= 100 || 'Menor o igual a 100 caracteres.';
        }],
        purpose: [function (v) {
          return !!v || 'El campo es requerido.';
        }, function (v) {
          return v && v.length <= 5000 || 'Menor o igual a 5000 caracteres.';
        }],
        description: [function (v) {
          return v == "" || v == undefined || v == null || v && v.length <= 1024 || 'Menor o igual a 1024 caracteres.';
        }],
        email: [function (v) {
          return PATTERNS_VALIDATION.EMAIL_GENERAL.test(v) || 'Ingrese un correo electrónico válido.';
        }]
      },
      permissions: [],
      default_config: {},
      autocompleteKey: 0
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['projects', 'catalogs', 'orgs', 'isDomainItc', 'has_dataplex_active'])), {}, {
    getClassTable: function getClassTable() {
      if (this.filter_enabled) {
        return 'col-md-9 col-sm-12';
      } else {
        return 'col-sm-12';
      }
    },
    getDomainConnections: function getDomainConnections() {
      return this.connections.filter(function (x) {
        return (x.domain == window.userInfo.domain || x.shared) && x.type !== "PLAYGROUND";
      });
    },
    getDomainBots: function getDomainBots() {
      return this.bots.filter(function (x) {
        return x.domain == window.userInfo.domain || x.shared;
      });
    }
  }),
  created: function created() {
    this.id = this.$router.currentRoute.params.id;
    this.mode = this.$route.meta.mode;
    if (this.mode == "edit") this.edit = true;
    if (this.mode == "view") this.view = true;
    if (this.id) {
      this.getProject();
      this.listPermissions();
    }
    this.getBots();
    this.getConnections();
    this.getDataCenters();
    this.getDefaultConfig();
  },
  methods: {
    test: function test() {
      console.log(this.stepper);
    },
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    formatDate: function formatDate(data) {
      if (data) return data ? data.substring(0, 19).replace("T", " ") : '';
      return "";
    },
    getConnections: function getConnections() {
      var _this = this;
      return project_service.getConnections().then(function (response) {
        _this.connections = response.data;
      });
    },
    getBots: function getBots() {
      var _this2 = this;
      bots_services.getAll().then(function (response) {
        _this2.bots = response.data;
      });
    },
    getProject: function getProject() {
      var _this3 = this;
      project_service.get(this.id).then(function (response) {
        _this3.project = response.data;
        _this3.single_datastore = _this3.project.version_metadata.datastores.length > 0 ? _this3.project.version_metadata.datastores[0] : null;
      });
    },
    onValidateForm: function onValidateForm() {
      if (this.permissions.filter(function (x) {
        return x.new && (!x.email || x.email && x.email.trim() == '');
      }).length > 0) {
        tasks.toast.warning("Debe registrar correos válidos en las restricciones.");
        return false;
      }
      return true;
    },
    onSaveProject: function onSaveProject() {
      var _this4 = this;
      if (this.$refs.permission_form && !this.$refs.permission_form.validateForm()) return;
      if (!this.$refs.form_project.validate()) {
        tasks.toast.warning("Revise los campos de pasos anteriores.");
        return;
      }
      if (!this.onValidateForm()) return;
      console.log("datastore", this.single_datastore);
      //return
      this.project.permissions = this.project.private_access ? this.permissions : [];
      this.project.version_metadata.datastores = this.single_datastore ? [this.single_datastore] : [];
      project_service.create(this.project).then(function (response) {
        if (response.success) {
          tasks.toast.success("El registro se guardó correctamente.");
          _this4.onCancelar();
        } else {
          if (response.message) {
            tasks.toast.error(response.message);
          } else {
            tasks.toast.error("No se pudo guardar el registro.");
          }
        }
      });
    },
    onUpdateProject: function onUpdateProject() {
      var _this5 = this;
      if (this.$refs.permission_form && !this.$refs.permission_form.validateForm()) return;
      if (!this.$refs.form_project.validate()) {
        tasks.toast.warning("Revise los campos de pasos anteriores.");
        return;
      }
      if (!this.onValidateForm()) return;
      this.project.permissions = this.project.private_access ? this.permissions : [];
      this.project.version_metadata.datastores = this.single_datastore ? [this.single_datastore] : [];
      project_service.update(this.id, this.project).then(function (response) {
        if (response.success) {
          _this5.getProject();
          _this5.listPermissions();
          tasks.toast.success("El registro se guardó correctamente.");
        } else {
          if (response.message) {
            tasks.toast.error(response.message);
          } else {
            tasks.toast.error("No se pudo guardar el registro.");
          }
        }
      });
    },
    onCancelar: function onCancelar() {
      this.$router.push({
        name: 'ProjectManagement'
      });
    },
    getDataCenters: function getDataCenters() {
      var _this6 = this;
      return data_center_services.getAll().then(function (response) {
        console.log(response);
        if (response.success) {
          _this6.datastore = response.data;
        }
      });
    },
    listPermissions: function listPermissions() {
      var _this7 = this;
      project_service.getPermissions(this.id).then(function (response) {
        _this7.permissions = [];
        response.data.forEach(function (item) {
          var obj = Object.assign({}, item);
          obj.email = "" + obj.email;
          delete obj.id;
          _this7.permissions.push(obj);
        });
      });
    },
    validateAndNext: function validateAndNext() {
      if (!this.$refs.form_project.validate()) {
        return;
      }
      this.stepper += 1;
    },
    openDataCenterDialog: function openDataCenterDialog() {
      this.$refs.dialogDatacenter.onOpen();
    },
    saveDataCenter: function saveDataCenter() {
      this.$refs.DataCenterRef.handleSave();
    },
    onSaveDatacenter: function onSaveDatacenter(id) {
      var _this8 = this;
      console.log("id generado", id);
      this.getDataCenters().then(function () {
        var find = _this8.datastore.find(function (dc) {
          return dc.datacenter_id == id;
        });
        console.log("single ds", find);
        _this8.single_datastore = find;
        _this8.$refs.dialogDatacenter.onClose();
      });
    },
    openChannelDialog: function openChannelDialog() {
      this.$refs.dialogChannel.onOpen();
    },
    saveChannel: function saveChannel() {
      this.$refs.ChannelRef.handleSave();
    },
    onSaveChannel: function onSaveChannel(id) {
      var _this9 = this;
      console.log("id generado", id);
      this.getConnections().then(function () {
        var find = _this9.connections.find(function (ch) {
          return ch.id == id;
        });
        console.log("channel", find);
        _this9.project.connections = [id];
        _this9.$refs.dialogChannel.onClose();
        _this9.autocompleteKey++;
      });
    },
    printChannel: function printChannel() {
      console.log("channels", this.project);
    },
    getDefaultConfig: function getDefaultConfig() {
      var _this0 = this;
      project_service.getDefaultConfig().then(function (response) {
        _this0.default_config = response.data;
      });
    }
  }
};